import dynamic from "next/dynamic";

export const OurValues = dynamic(() => import("./component"));
